import { render, staticRenderFns } from "./WxMyProfile.vue?vue&type=template&id=c2a18df6&scoped=true&"
import script from "./WxMyProfile.vue?vue&type=script&lang=js&"
export * from "./WxMyProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a18df6",
  null
  
)

export default component.exports